"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectToFormData = exports.containsBinaryData = void 0;
var tslib_1 = require("tslib");
var is_buffer_1 = tslib_1.__importDefault(require("is-buffer"));
var index_js_1 = require("../../utils/index.js");
var isPrimitive = function (value) {
    return typeof value === "object" ? value === null : typeof value !== "function";
};
var isObject = function (value) { return value === Object(value); };
var isClassInstance = function (value) {
    return typeof value === "object" && !(value instanceof Array) && value.constructor !== Object;
};
var containsBinaryData = function (data) {
    if (isPrimitive(data)) {
        return false;
    }
    else if (isClassInstance(data)) {
        return true;
    }
    else if (Array.isArray(data)) {
        return data.reduce(function (result, value) { return result || (0, exports.containsBinaryData)(value); }, false);
    }
    else if (isObject(data)) {
        return Object.keys(data).reduce(function (result, key) { return result || (0, exports.containsBinaryData)(data[key]); }, false);
    }
    return false;
};
exports.containsBinaryData = containsBinaryData;
var objectToFormData = function (obj, keyFormatter, ignoredKeys) {
    if (keyFormatter === void 0) { keyFormatter = index_js_1.toSnakeCase; }
    if (ignoredKeys === void 0) { ignoredKeys = []; }
    var formData = new FormData();
    var appendFormData = function (data, path) {
        if (path === void 0) { path = ""; }
        if ((0, index_js_1.isBlob)(data)) {
            // Blob
            formData.append(path, data);
        }
        else if (Array.isArray(data)) {
            // Array
            for (var i = 0; i < data.length; i++) {
                appendFormData(data[i], "".concat(path, "[").concat(i, "]"));
            }
        }
        else if (data && isObject(data) && !(0, is_buffer_1.default)(data)) {
            // Object
            for (var key in data) {
                appendFormData(data[key], path ? "".concat(path, ".").concat(key) : key);
            }
        }
        else if (data !== null && typeof data !== "undefined") {
            // symbols & Buffer
            formData.append(path, data);
        }
    };
    appendFormData((0, index_js_1.isBlob)(obj) ? obj : (0, index_js_1.transformKeys)(obj, keyFormatter, ignoredKeys));
    return formData;
};
exports.objectToFormData = objectToFormData;
//# sourceMappingURL=payload.js.map